import type { FC } from "react";

import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { QueryBarWebsiteItem } from "@similarweb/ui-components";
import { Text } from "@similarweb/ui-components/foundations";

import { useTranslation } from "pro-features/components/WithTranslation/src/I18n";

export const VS: FC = () => {
    const translate = useTranslation();
    return (
        <Text
            fontVariant="body1"
            color={colorsPalettes.carbon[300]}
        >
            {translate("common.vs")}
        </Text>
    );
};

const QueryBarWebsiteItemStyled = styled(QueryBarWebsiteItem)<{ $isLast?: boolean }>`
    background-color: ${colorsPalettes.carbon[50]};
    max-width: 198px;
    @media (max-width: 1280px) {
        max-width: 180px;
    }
    ${({ $isLast }) => $isLast && `margin-left: 16px;`}
`;
